import { render, staticRenderFns } from "./AddressIsDefault.vue?vue&type=template&id=5556c24e&"
import script from "./AddressIsDefault.vue?vue&type=script&lang=ts&"
export * from "./AddressIsDefault.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports